"use client";

import { useRouter as useNextRouter, useParams } from "next/navigation";
import { useMemo } from "react";
import { defaultLanguage, isLanguage } from "./config";
import { localizeHref } from "./paths";

export function useRouteLanguage(): HrefLang {
  const locale = useParams()?.locale;
  return isLanguage(locale) ? locale : defaultLanguage;
}

export function useRouter() {
  const router = useNextRouter();
  const locale = useRouteLanguage();
  return useMemo(
    () => ({
      ...router,
      push: (href: string, options?: Parameters<typeof router.push>[1]) =>
        router.push(localizeHref(href, locale), options),
      replace: (href: string, options?: Parameters<typeof router.replace>[1]) =>
        router.replace(localizeHref(href, locale), options),
      prefetch: (href: string, options?: Parameters<typeof router.prefetch>[1]) =>
        router.prefetch(localizeHref(href, locale), options),
    }),
    [router, locale]
  );
}
